export enum THEME {
  DARK = "dark",
  LIGHT = "light"
}
